/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener
 * crm-screener
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { ScreenerGeneratedDocument } from './ScreenerGeneratedDocument';
import {
    ScreenerGeneratedDocumentFromJSON,
    ScreenerGeneratedDocumentFromJSONTyped,
    ScreenerGeneratedDocumentToJSON,
} from './ScreenerGeneratedDocument';

/**
 * 
 * @export
 * @interface ListGeneratedReports200Response
 */
export interface ListGeneratedReports200Response {
    /**
     * 
     * @type {Array<ScreenerGeneratedDocument>}
     * @memberof ListGeneratedReports200Response
     */
    data?: Array<ScreenerGeneratedDocument>;
}

/**
 * Check if a given object implements the ListGeneratedReports200Response interface.
 */
export function instanceOfListGeneratedReports200Response(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function ListGeneratedReports200ResponseFromJSON(json: any): ListGeneratedReports200Response {
    return ListGeneratedReports200ResponseFromJSONTyped(json, false);
}

export function ListGeneratedReports200ResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): ListGeneratedReports200Response {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'data': !exists(json, 'data') ? undefined : ((json['data'] as Array<any>).map(ScreenerGeneratedDocumentFromJSON)),
    };
}

export function ListGeneratedReports200ResponseToJSON(value?: ListGeneratedReports200Response | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'data': value.data === undefined ? undefined : ((value.data as Array<any>).map(ScreenerGeneratedDocumentToJSON)),
    };
}

